import { initResponsiveGauge } from './responsiveGauge/responsiveGauge';
import { initResponsiveGridTable } from './responsiveGridTable/responsiveGridTable';
import { initResponsiveLine } from './responsiveLine/responsiveLine';
import { initResponsiveStat } from './responsiveStat/responsiveStat';
import { initResponsiveTable } from './responsiveTable/responsiveTable';

let manifest;

// eslint-disable-next-line import/prefer-default-export
export const initManifest = (locale = 'en_us') => {
  const ResponsiveGridTable = initResponsiveGridTable(locale);
  const ResponsiveGauge = initResponsiveGauge(locale);
  const ResponsiveLine = initResponsiveLine(locale);
  const ResponsiveStat = initResponsiveStat(locale);
  const ResponsiveTable = initResponsiveTable(locale);

  manifest = {
    ResponsiveGauge,
    ResponsiveGridTable,
    ResponsiveLine,
    ResponsiveStat,
    ResponsiveTable,
  };

  return manifest;
};
